var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m285.307 225.715h50.283v147.735h-50.283z",
    fill: "#77b0fb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m176.41 225.715h50.283v147.735h-50.283z",
    fill: "#77b0fb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m67.514 225.715h50.283v147.735h-50.283z",
    fill: "#77b0fb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m325.591 222.105h10v154.956h-10z",
    fill: "#6b9ee2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m216.694 222.105h10v154.956h-10z",
    fill: "#6b9ee2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m107.797 222.105h10v154.956h-10z",
    fill: "#6b9ee2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m394.203 225.715h50.283v147.735h-50.283z",
    fill: "#77b0fb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m434.487 222.105h10v154.956h-10z",
    fill: "#6b9ee2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 127.519,
    fill: "#dcc23d",
    r: 54.129
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250.3,
    cy: 127.519,
    fill: "#f4d844",
    r: 48.076,
    transform: "matrix(.707 -.707 .707 .707 -16.859 214.338)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m248.992 98.349c0-3.866 3.134-7 7-7s7 3.134 7 7v1.617c1.028.455 2.01 1.003 2.933 1.634 2.982 2.04 5.336 4.966 6.682 8.429 1.389 3.594-.398 7.634-3.992 9.023s-7.634-.398-9.023-3.992c-.302-.779-.846-1.446-1.541-1.922-.662-.452-1.476-.716-2.363-.716-1.4 0-2.446.478-3.081 1.189-.253.283-.463.644-.621 1.055-.142.372-.217.771-.217 1.173 0 .796.33 1.614 1.054 2.261 1.079.964 2.964 1.431 4.84 1.895 4.679 1.158 9.332 2.31 13.508 8.143v.028c.612.855 1.119 1.699 1.521 2.524.403.827.754 1.759 1.051 2.779.487 1.669.722 3.319.722 4.908 0 3.798-1.241 7.564-3.524 10.69l-.013-.01c-1.943 2.654-4.63 4.833-7.934 6.157v1.475c0 3.866-3.134 7-7 7s-7-3.134-7-7v-1.292c-1.396-.526-2.718-1.213-3.942-2.038-3.101-2.091-5.567-5.101-7.01-8.676-1.435-3.579.304-7.643 3.883-9.078s7.643.304 9.078 3.883c.371.92 1.03 1.711 1.869 2.277.798.538 1.769.851 2.816.851.68 0 1.242-.072 1.692-.203.994-.29 1.773-.862 2.295-1.577v-.028c.512-.701.79-1.558.79-2.432 0-.399-.04-.746-.121-1.025-.03-.104-.107-.283-.231-.537-.108-.221-.21-.403-.304-.538l-.013.009c-1.196-1.671-3.327-2.199-5.469-2.729-3.54-.876-7.097-1.756-10.801-5.066-3.956-3.536-5.757-8.12-5.757-12.652 0-2.097.395-4.185 1.147-6.149.738-1.924 1.85-3.753 3.3-5.375 1.801-2.015 4.087-3.652 6.778-4.685v-1.281z",
    fill: "#e39069"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.621 119.922-89.309 56.991c-5.014 3.199-7.229 9.096-5.563 14.805s6.706 9.488 12.653 9.488h6.426s79.654 0 79.654 0h123.518s14.621 0 14.621 0h194.977c5.947 0 10.987-3.779 12.653-9.488s-.549-11.606-5.563-14.805l-89.309-56.991-111.016-70.842c-10.214-6.518-22.513-6.518-32.727 0l-111.016 70.842zm127.379 55.425c-26.414 0-47.827-21.413-47.827-47.827s21.413-47.827 47.827-47.827 47.827 21.413 47.827 47.827-21.413 47.827-47.827 47.827z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.482 218.743v-23.162h-79.654v23.162c0 6.4 6.609 11.637 14.686 11.637h50.283c8.077 0 14.685-5.237 14.685-11.637z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.725 195.581v23.162c0 6.4 6.609 11.637 14.686 11.637h50.283c8.077 0 14.685-5.237 14.685-11.637v-23.162z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.621 195.581v23.162c0 6.4 6.609 11.637 14.686 11.637h50.283c8.077 0 14.685-5.237 14.685-11.637v-23.162z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.518 195.581v23.162c0 6.4 6.609 11.637 14.686 11.637h50.283c8.077 0 14.685-5.237 14.685-11.637v-23.162z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.797 368.785h-50.283c-8.077 0-14.686 5.237-14.686 11.637v27.023h79.654v-27.023c0-6.4-6.608-11.637-14.685-11.637z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.41 368.785c-8.077 0-14.686 5.237-14.686 11.637v27.023h79.654v-27.023c0-6.4-6.608-11.637-14.685-11.637z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m285.307 368.785c-8.077 0-14.686 5.237-14.686 11.637v27.023h79.654v-27.023c0-6.4-6.609-11.637-14.685-11.637z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m379.518 380.422v27.023h79.654v-27.023c0-6.4-6.608-11.637-14.685-11.637h-50.283c-8.077 0-14.686 5.237-14.686 11.637z",
    fill: "#2b4c9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m459.172 398.445h-410.077c-8.441 0-15.346 6.906-15.346 15.346v27.347h444.502v-27.347c0-8.44-6.906-15.346-15.346-15.346z",
    fill: "#6b9ee2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.716 408.446c-.625 1.666-.967 3.468-.967 5.345v27.347h434.503v-27.347c0-2.921-2.426-5.346-5.347-5.346h-428.189z",
    fill: "#77b0fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.665 429.138h-441.33c-10.635 0-19.335 8.701-19.335 19.335v19.336h480v-19.336c0-10.634-8.701-19.335-19.335-19.335z",
    fill: "#2b4c9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.c51cd7eb2f6a9c968585735e4011fbf1.svg";
export { ForwardRef as ReactComponent };